module.exports = __webpack_public_path__ + "img/banner2.5243e992.png";